// Extrae el payload base64 de un data URI ("data:image/webp;base64,<payload>").
// Si el string ya viene sin el prefijo, lo devuelve tal cual.
//
// Existe para que los endpoints que decodifican con Buffer.from(x, 'base64')
// nunca reciban el prefijo por error — mandarlo crudo corrompe la cabecera de
// la imagen en silencio (ver PR #198/#200: MiembroModal lo mandaba crudo y la
// subida de foto fallaba siempre con 422).
export function extraerBase64DeDataUri(uri: string): string {
  return uri.split(',')[1] ?? uri;
}
